import { render, staticRenderFns } from "./OfficialGameCard.vue?vue&type=template&id=624967d6&"
import script from "./OfficialGameCard.vue?vue&type=script&lang=js&"
export * from "./OfficialGameCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficialGameCard.vue?vue&type=style&index=0&id=624967d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports